import { render } from "./SWUpdate.vue?vue&type=template&id=40884632&ts=true"
import script from "./SWUpdate.vue?vue&type=script&lang=ts"
export * from "./SWUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__